/**
 * @param props
 * @return {{subscribe(): void, loading: boolean, message: null, email: null}}
 */
export default (props) => {
    return {
        loading: false,
        success: false,
        message: null,
        email: null,
        subscribe() {
            this.loading = true;
            fetch('/newsletter/subscribe.json', {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: this.email
                })
            })
                .then((r) => r.json())
                .then(( data ) => {
                    if ( data.success ) {
                        this.email = null;
                    }
                    this.success = data.success;
                    this.message = data.service.message;
                    this.loading = false;
                });
        },
    }
};